import { FEATURE_CONTROLS_TYPES } from "../FeatureControlsHelper";

export const AutoDiscoverNodeLinks = (customisationNode, customisationRestriction, newFormatNodeListData) => {
    console.log("customisationNode: ", customisationNode, "customisationRestriction: ", customisationRestriction, "newFormatNodeListData: ", newFormatNodeListData);

    const featureCustomisationConfig = customisationNode?.featureData?.feature?.customisation;
    if (!featureCustomisationConfig) {
        console.warn("No feature customisation config found for node: ", customisationNode);
        return false;
    }

    const tabId = customisationRestriction?.tab;
    if (!tabId) {
        console.warn("No tab ID found in customisation restriction: ", customisationRestriction);
        return false;
    }
    const tabData = featureCustomisationConfig.find(tab => tab.tabKey === tabId);
    if (!tabData) {
        console.warn("No tab data found for tab ID: ", tabId);
        return false;
    }
    
    const groupId = customisationRestriction?.group;
    if (!groupId) {
        console.warn("No group ID found in customisation restriction: ", customisationRestriction);
        stepThroughGroups(tabData, newFormatNodeListData, tabId);
        return true;
    }
    const groupData = tabData.options.find(group => group.varKey === groupId);
    if (!groupData) {
        console.warn("No group data found for group ID: ", groupId);
        stepThroughGroups(tabData, newFormatNodeListData, tabId);
        return true;
    }

    const familyId = customisationRestriction?.family;
    if (!familyId) {
        console.warn("No family ID found in customisation restriction: ", customisationRestriction);
        stepThroughFamilies(groupData, newFormatNodeListData, `${tabId}.${groupId}`);
        return true;
    }
    const familyData = groupData.variables.find(family => family.varName === familyId);
    if (!familyData) {
        console.warn("No family data found for family ID: ", familyId);
        stepThroughFamilies(groupData, newFormatNodeListData, `${tabId}.${groupId}`);
        return true;
    }

    searchForAutoDiscoverNodes(familyData, newFormatNodeListData, `${tabId}.${groupId}.${familyId}`);
    return true;
};

const stepThroughGroups = (tabData, newFormatNodeListData, path) => {
    console.log("stepThroughGroups called with tab: ", tabData, "newFormatNodeListData: ", newFormatNodeListData);

    if (!tabData || !tabData.options) {
        console.warn("No options found in tab data: ", tabData);
        return false;
    }
    for (const group of tabData.options) {
        if (!group || !group.variables) {
            console.warn("No variables found in group data: ", group);
            continue;
        }
        stepThroughFamilies(group, newFormatNodeListData, `${path}.${group.varKey}`);
    }
};

const stepThroughFamilies = (groupData, newFormatNodeListData, path) => {
    console.log("stepThroughFamilies called with group: ", groupData, "newFormatNodeListData: ", newFormatNodeListData);

    if (!groupData || !groupData.variables) {
        console.warn("No variables found in group data: ", groupData);
        return false;
    }
    for (const family of groupData.variables) {
        if (!family || !family.valSchema) {
            console.warn("No value schema found in family data: ", family);
            continue;
        }
        searchForAutoDiscoverNodes(family, newFormatNodeListData, `${path}.${family.varName}`);
    }
};

const searchForAutoDiscoverNodes = (familyData, newFormatNodeListData, path, parentNode = null) => {
    if (!newFormatNodeListData || !newFormatNodeListData.subNodes) {
        console.warn("No subNodes found in new format node list data: ", newFormatNodeListData);
        return false;
    }
    for (let i = 0; i < newFormatNodeListData.subNodes.length; i++) {
        const nodeData = newFormatNodeListData.subNodes[i];
        if (!nodeData || !nodeData.id) {
            console.warn("Invalid node data found: ", nodeData);
            continue;
        }
        if (nodeData.autoDiscover || parentNode?.autoDiscover) {
            console.log("Found autoDiscover node: ", nodeData);
            const autoDiscoverData = nodeData.autoDiscover || parentNode?.autoDiscover;
            if (nodeData.linkable && nodeData.link === null) {
                const linkKey = searchForMatchingDataLink(familyData.valSchema, autoDiscoverData);
                if (linkKey) {
                    nodeData.link = `${path}.${linkKey}`;
                    nodeData.name = `${path}.${linkKey}`;
                    console.log(`Auto-discovered link for node: ${nodeData.link}`, nodeData);
                }
            }
            if (nodeData.valueLink && nodeData.name === '<No Value>' && nodeData.autoDiscover) {
                const linkValue = searchForMatchingValueLink(familyData.valSchema, nodeData, parentNode.autoDiscover);
                if (linkValue) {
                    nodeData.name = linkValue;
                    console.log(`Auto-discovered value link for node: ${linkValue}`, nodeData);
                }
            }
        }
        if (nodeData.subNodes && Array.isArray(nodeData.subNodes)) {
            searchForAutoDiscoverNodes(familyData, nodeData, path, newFormatNodeListData);
        }
    }
}

const searchForMatchingDataLink = (valSchema, autoDiscoverList) => {
    for (let key in valSchema) {
        if (autoDiscoverList.includes(key) || autoDiscoverList.includes(key.toLowerCase()) || autoDiscoverList.includes(key.replace(/[-_ ]/g, '').toLowerCase())) {
            console.log(`Found matching data link: ${key}`);
            return key;
        }
    }
}

const searchForMatchingValueLink = (valSchema, nodeData, parentAutoDiscoverList) => {
    const autoDiscoverKeyListToUse = nodeData.autoDiscoverKeys || parentAutoDiscoverList;
    for (let key in valSchema) {
        // Note we don't need a key, but id a key exists in the parent or we have keys provided, we only allow values that match those keys
        if (!autoDiscoverKeyListToUse || autoDiscoverKeyListToUse.includes(key) || autoDiscoverKeyListToUse.includes(key.toLowerCase()) || autoDiscoverKeyListToUse.includes(key.replace(/[-_ ]/g, '').toLowerCase())) {
            console.log(`Found matching value key: ${key}`);
            const variableData = valSchema[key];
            const autoDiscoverValuesList = nodeData.autoDiscover;
            if (variableData.valOptions) {
                for (let option of variableData.valOptions) {
                    if (option && option.value && typeof option.value === 'string' && (autoDiscoverValuesList.includes(option.value) || autoDiscoverValuesList.includes(option.value.toLowerCase()) || autoDiscoverValuesList.includes(option.value.replace(/[-_ ]/g, '').toLowerCase()))) {
                        console.log(`Found matching value: ${option.value} for key: ${key}`);
                        return option.value;
                    }
                }
            } else
            if (variableData.type === 'toggle' || variableData.dashboardDisplayType === 'toggle') {
                console.log(`Found matching toggle value: ${key}`);
                // For toggles we can return "True" or "False" as the value, if the autoDiscoverValuesList container true or false
                if (autoDiscoverValuesList.includes('true') || autoDiscoverValuesList.includes('True')) {
                    return 'True';
                } else if (autoDiscoverValuesList.includes('false') || autoDiscoverValuesList.includes('False')) {
                    return 'False';
                }
            }
        }
    }
}

export const AutoPopulateCustomFields = (customisationNode, customisationRestriction, newFormatNodeListData, addCustomFieldFunction) => {
    console.log("autoPopulateCustomFields called with customisationNode: ", customisationNode, "customisationRestriction: ", customisationRestriction, "newFormatNodeListData: ", newFormatNodeListData, "addCustomFieldFunction: ", addCustomFieldFunction);

    const featureCustomisationConfig = customisationNode?.featureData?.feature?.customisation;
    if (!featureCustomisationConfig) {
        console.warn("No feature customisation config found for node: ", customisationNode);
        return false;
    }

    const tabId = customisationRestriction?.tab;
    if (!tabId) {
        console.warn("No tab ID found in customisation restriction: ", customisationRestriction);
        return false;
    }
    const tabData = featureCustomisationConfig.find(tab => tab.tabKey === tabId);
    if (!tabData) {
        console.warn("No tab data found for tab ID: ", tabId);
        return false;
    }
    console.log("Found tab data: ", tabData);
    
    const groupId = customisationRestriction?.group;
    if (!groupId) {
        console.warn("No group ID found in customisation restriction: ", customisationRestriction);
        // stepThroughGroups(tabData, newFormatNodeListData, tabId);
        return false;
    }
    const groupData = tabData.options.find(group => group.varKey === groupId);
    if (!groupData) {
        console.warn("No group data found for group ID: ", groupId);
        // stepThroughGroups(tabData, newFormatNodeListData, tabId);
        return false;
    }
    console.log("Found group data: ", groupData);

    const familyId = customisationRestriction?.family;
    if (!familyId) {
        console.warn("No family ID found in customisation restriction: ", customisationRestriction);
        // stepThroughFamilies(groupData, newFormatNodeListData, `${tabId}.${groupId}`);
        return false;
    }
    const familyData = groupData.variables.find(family => family.varName === familyId);
    if (!familyData) {
        console.warn("No family data found for family ID: ", familyId);
        // stepThroughFamilies(groupData, newFormatNodeListData, `${tabId}.${groupId}`);
        return false;
    }
    console.log("Found family data: ", familyData);

    const featureId = customisationNode?.featureData?.feature?._id;
    console.log("Feature ID: ", featureId);
    if (!featureId) {
        console.warn("No feature ID found in customisation node: ", customisationNode);
        return false;
    }
    // if (FEATURE_CONTROLS_TYPES.hasOwnProperty(fieldTypeKey) && FEATURE_CONTROLS_TYPES[fieldTypeKey].newFormatCustomisationField) {
        // const fieldTypeData = FEATURE_CONTROLS_TYPES[fieldTypeKey];
        // addCustomFieldFunction(selectedNewFormatFeatureId, node.parent.subNodes, fieldTypeKey, fieldTypeData)
    // }

    let fieldCount = 1;
    for (const valSchemaKey in familyData.valSchema) {
        const valSchemaEntry = familyData.valSchema[valSchemaKey];
        console.log("Processing valSchema entry: ", valSchemaKey, valSchemaEntry, FEATURE_CONTROLS_TYPES);
        const fieldLabel = valSchemaEntry?.label ?? valSchemaKey;
        const fieldType = valSchemaEntry?.type;
        let fieldData = null;
        let fieldTypeKey = null;
        for (const typeKey in FEATURE_CONTROLS_TYPES) {
            const typeData = FEATURE_CONTROLS_TYPES[typeKey];
            if (typeData.type === fieldType) {
                fieldData = typeData;
                fieldTypeKey = typeKey;
                break;
            }
        }
        if (fieldTypeKey && fieldData.newFormatCustomisationField) {
            const fieldName = valSchemaKey + '_' +  fieldType;
            fieldCount++;
            const fieldTypeData = fieldData;
            console.log(`Adding custom field: ${fieldName} of type: ${fieldType} for value schema key: ${valSchemaKey}`, fieldTypeData);
            const newNode = addCustomFieldFunction(featureId, newFormatNodeListData.subNodes, fieldTypeKey, fieldTypeData);
            console.log("Added new custom field node: ", newNode);
            newNode.name = fieldName;
            newNode.subNodes[2].name = fieldLabel;
            const dataLink = `${tabId}.${groupId}.${familyId}.${valSchemaKey}`;
            newNode.subNodes[3].link = dataLink;
            newNode.subNodes[3].name = dataLink;
            console.log(`Set data link for new custom field node: ${dataLink}`, newNode);
        }
    }
    /* if (fieldCount > 1) {
        console.log(`Auto-populated ${fieldCount - 1} custom fields based on family data.`);
        searchForAutoDiscoverNodes(familyData, newFormatNodeListData, `${tabId}.${groupId}.${familyId}`);
    } */
    return fieldCount > 1;
}

export const UpdateDataLinkGroups = (newFormatNodeListData, newTabId = null, newGroupId = null, newFamilyId = null) => {
    // Iterate through properties of newFormatNodeData looking for dataLink strings, split them and update the relevant section with the new IDs
    if (!newFormatNodeListData || !newFormatNodeListData.subNodes) {
        console.warn("No subNodes found in new format node list data: ", newFormatNodeListData);
        // Step through properties of objects and elements of arrays to find any links that may be nested deeper in the structure
        if (Array.isArray(newFormatNodeListData)) {
            for (let i = 0; i < newFormatNodeListData.length; i++) {
                const item = newFormatNodeListData[i];
                if (typeof item === 'object' && item !== null) {
                    UpdateDataLinkGroups(item, newTabId, newGroupId, newFamilyId);
                }
            }
        } else
        for (let key in newFormatNodeListData) {
            if (newFormatNodeListData.hasOwnProperty(key)) {
                const value = newFormatNodeListData[key];
                if (key !== 'parent') {
                    if (typeof value === 'object' && value !== null) {
                        UpdateDataLinkGroups(value, newTabId, newGroupId, newFamilyId);
                    } else
                    if ((key.toLowerCase().includes('link') && typeof value === 'string') || (key.toLowerCase().includes('name') && typeof value === 'string' && value.split('.').length === 4)) {
                        const linkParts = value.split('.');
                        if (linkParts.length === 4) {
                            const [tabId, groupId, familyId, fieldId] = linkParts;
                            const updatedTabId = newTabId || tabId;
                            const updatedGroupId = newGroupId || groupId;
                            const updatedFamilyId = newFamilyId || familyId;
                            const updatedLink = `${updatedTabId}.${updatedGroupId}.${updatedFamilyId}.${fieldId}`;
                            newFormatNodeListData[key] = updatedLink;
                            console.log(`Updated data link for key: ${key} to: ${updatedLink}`, newFormatNodeListData);
                        }
                    }
                }
            }
        }
        return;
    }
    for (let i = 0; i < newFormatNodeListData.subNodes.length; i++) {
        const nodeData = newFormatNodeListData.subNodes[i];
        if (!nodeData) {
            console.warn("Invalid node data found: ", nodeData);
            continue;
        }
        if (nodeData.link && typeof nodeData.link === 'string') {
            const linkParts = nodeData.link.split('.');
            if (linkParts.length === 4) {
                const [tabId, groupId, familyId, fieldId] = linkParts;
                const updatedTabId = newTabId || tabId;
                const updatedGroupId = newGroupId || groupId;
                const updatedFamilyId = newFamilyId || familyId;
                const updatedLink = `${updatedTabId}.${updatedGroupId}.${updatedFamilyId}.${fieldId}`;
                nodeData.link = updatedLink;
                console.log(`Updated data link for node: ${nodeData.name} to: ${updatedLink}`, nodeData);
            }
        }
        if (nodeData.name && typeof nodeData.name === 'string' && nodeData.name.split('.').length === 4) {
            const nameParts = nodeData.name.split('.');
            if (nameParts.length === 4) {
                const [tabId, groupId, familyId, fieldId] = nameParts;
                const updatedTabId = newTabId || tabId;
                const updatedGroupId = newGroupId || groupId;
                const updatedFamilyId = newFamilyId || familyId;
                const updatedName = `${updatedTabId}.${updatedGroupId}.${updatedFamilyId}.${fieldId}`;
                nodeData.name = updatedName;
                console.log(`Updated name for node: ${nodeData.name} to: ${updatedName}`, nodeData);
            }
        }
        if (nodeData.subNodes && Array.isArray(nodeData.subNodes)) {
            UpdateDataLinkGroups(nodeData, newTabId, newGroupId, newFamilyId);
        }
    }
}
